import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Chart } from "primereact/chart";
import { Slider } from "primereact/slider";
import { useSelector, useDispatch } from 'react-redux';
import * as jobConstants from "../../enums/jobs";
import moment from "moment";

import {
  setFilterReportType,
  fetchCurrentReportData,
} from "./reportSlice";

export const CurrentStatusExpendedView = () => {
  const navigate = useNavigate();
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const protrackReports = useSelector((state) => state.reports);
  const jobState = useSelector((state) => state.job);
  const {
    userId,
    clientId,
    appLanguage,
  } = jobState;
  const {
    currentReportList,
    currentRPCReportList,
    reportStartDate,
    reportEndDate,
    filterChannelType,
    filterDocType,
    tabViewType,
    filterReportType,
  } = protrackReports;
  const categories = jobConstants.REPORT_FILTER_TYPE;
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(currentReportList, "currentReportList-currentReportList")
    let rpcGraphVol = currentReportList[0]?.CommStatusGraph ? currentReportList[0]?.CommStatusGraph : [];

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const data = {
      labels: rpcGraphVol.map(item => item.TimeGroup),
      datasets: [
        {
          type: "line",
          label: appLanguage["report.current-status.label.received"],
          fill: false,
          tension: 0.7,
          backgroundColor: '#BFBFBF',
          data: rpcGraphVol.map(item => item.totalcommsreceivedG),
        },
        {
          type: "line",
          label: appLanguage["report.current-status.label.processed"],
          fill: false,
          tension: 0.5,
          backgroundColor: '#7F7F7F',
          data: rpcGraphVol.map(item => item.totalcommsprocessedG),
        },
        {
          type: "line",
          label: appLanguage["report.current-status.label.complete"],
          fill: false,
          tension: 0.3,
          backgroundColor: '#C00000',
          data: rpcGraphVol.map(item => item.totalcommsCompleteG),
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          display: false
        },
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            display: false,
          },
        },
        y: {
          stacked: false,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };
    setChartData(data);
    setChartOptions(options);
  }, [currentReportList, appLanguage]);

  const changeReportType = (e) => {
    dispatch(setFilterReportType(e.value));
    let filterParams = {
      clientId: clientId,
      userId: userId,
      typeId: tabViewType,
      channelType: filterChannelType.join("|"),
      filterType: filterDocType,
      fromDate: moment(reportStartDate).format("YYYY-MM-DD"),
      toDate: moment(reportEndDate).format("YYYY-MM-DD"),
      reportType: e.value,
    };
    dispatch(fetchCurrentReportData(filterParams));
  }

  const downloadRPCReport = () => {
    downloadCsv(currentRPCReportList, 'rpc_report.csv');
  }

  // Convert JSON to CSV
  const jsonToCsv = (jsonData) => {
    const isArray = Array.isArray(jsonData);
    if (isArray) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];
      csvRows.push(headers.join(','));
      jsonData.forEach(item => {
        const values = headers.map(header => {
          const value = item[header];
          return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
        });
        csvRows.push(values.join(','));
      });
      return csvRows.join('\n');
    } else {
      const headers = Object.keys(jsonData);
      const values = headers.map(header => {
        const value = jsonData[header];
        return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
      });
      return `${headers.join(',')}\n${values.join(',')}`;
    }
  };

  // Trigger CSV download
  const downloadCsv = (jsonData, fileName) => {
    const csvData = jsonToCsv(jsonData);
    console.log('CSV Data:', csvData);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  return (
    <div className="comms-sla-met-wrapper">
      <div className="comms-sla-met-inner-wrap">
        <div className="left-col box-white">
          {/* <h3>
            <div className="range-slider-wrapper">
              <div className="range-slides ds-received">
                <span className="range-text">{appLanguage["report.current-status.label.received"]}</span>
                <Slider
                  value={value}
                  onChange={(e) => setValue(e.value)}
                  className="w-4rem"
                />
              </div>
              <div className="range-slides ds-processed">
                <span className="range-text">{appLanguage["report.current-status.label.processed"]}</span>
                <Slider
                  value={value}
                  onChange={(e) => setValue(e.value)}
                  className="w-4rem"
                />
              </div>
              <div className="range-slides ds-complete">
                <span className="range-text">{appLanguage["report.current-status.label.complete"]}</span>
                <Slider
                  value={value}
                  onChange={(e) => setValue(e.value)}
                  className="w-4rem"
                />
              </div>
            </div>
          </h3> */}

          <div className="card" style={{ minWidth: '0px' }}>
            <Chart
              style={{ height: '515px' }}
              type="line"
              data={chartData}
              options={chartOptions}
            />
          </div>
        </div>
        <div className="right-col">
          <div className="applied-filter-box">
            <p className="title">Applied Filters</p>
            <p style={{ width: '110px' }}>{moment(reportStartDate).format("DD MMM YYYY")} – {moment(reportEndDate).format("DD MMM YYYY")}</p>
            <p>{filterChannelType == 0 ? 'DOCUMENT' : filterChannelType == 1 ? 'EMAIL' : filterChannelType == 2 ? 'SMS' : 'ALL'}</p>
            <p>{filterDocType === 1 ? 'BATCH' : filterDocType === 2 ? 'ADHOC' : 'ALL'}</p>
          </div>
          <div className="comms-btn-wrapper">
            <button className="return-icon-comms" onClick={() => navigate("/reports")}>Return</button>
            <button className="download-icon-comms" onClick={downloadRPCReport}>Download</button>
          </div>
        </div>
      </div>
      {/* <hr className="footer-border" /> */}
    </div>
  );
};
